<ng-container *ngIf="pageLabel == '/order' || pageLabel == '/exploded-view'; else elseBlock">
  <div class="order-details-breadcrumb container" *ngIf="pageLabel == '/order'">
    <a [routerLink]="'orders'" class="back-link">
      <i class="material-icons">keyboard_arrow_left</i> {{ 'myAccount.orderDetails.backToOrders' | cxTranslate }}
    </a>
  </div>
  <div class="exploded-view-breadcrumb container" *ngIf="pageLabel == '/exploded-view'">
    <a
      [routerLink]="{ cxRoute: 'product', params: componentService.explodedViewReferrerProduct$ | async } | cxUrl"
      class="back-link"
    >
      <i class="material-icons">keyboard_arrow_left</i> {{ 'explodedView.backToReferrerProduct' | cxTranslate }}
    </a>
  </div>
</ng-container>
<ng-template #elseBlock>
  <div
    class="container"
    [ngClass]="{
      'breadcrumb-myaccount': pageLabel == '/my-account',
      'breadcrumb-personal-info': pageLabel == '/my-account/account-information',
      'breadcrumb-change-pass': pageLabel == '/my-account/change-password',
      'breadcrumb-edit-preferences': pageLabel == '/my-account/edit-preferences',
      'breadcrumb-add-employee': pageLabel == '/my-account/add-employee',
      'breadcrumb-edit-employee': pageLabel == '/my-account/edit-employee',
      'breadcrumb-pdp': typeCode == 'ProductPage',
      'breadcrumb-dealer': pageLabel == '/dealer-selection',
      'breadcrumb-unit': pageLabel == '/unit-selection',
      'breadcrumb-customer-service': pageLabel == '/customer-service',
      'breadcrumb-importcsv': pageLabel == '/import-cart',
      'breadcrumb-cart': pageLabel == '/cart' && !isSavingCart,
      'd-none': pageLabel == '/cart' && isSavingCart,
      'salesrep-breadcrumb': asmEnabled
    }"
  >
    <nav
      class="breadcrumb"
      [class.pdp-page]="template === 'ProductDetailsPageTemplate' || template === 'ShimanoOrderFormPageTemplate'"
    >
      <ng-container *ngIf="(crumbs$ | async)?.length > 3 && deviceDetectorService.isMobile(); else elseBlock">
        <span class="breadcrumb-item"> ... </span>
        <span *ngFor="let crumb of crumbs$ | async | slice : -3" class="breadcrumb-item">
          <a [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
        </span>
      </ng-container>
      <ng-template #elseBlock>
        <span *ngFor="let crumb of crumbs$ | async" class="breadcrumb-item">
          <a [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
        </span>
      </ng-template>
    </nav>
    <p
      class="pageTitle"
      [class.removeText]="isMobileEmptyCartPage(deviceDetectorService.isMobile(), isEmptyCart$ | async)"
      *ngIf="pageTitle && (isCartPage$ | async) && isEmptyCart$ | async"
    >
      {{ pageTitle }}
    </p>
  </div>
</ng-template>
